import * as moment from 'moment-timezone';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { MatSnackBar } from '@angular/material';
import { Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { ChallengeService, TeamMembershipStatus } from 'app/shared/services/challenge.service';
import { UserService } from 'app/shared/services/user.service';
import { Subject } from 'rxjs';
/**
 * Component to display tab for next challenge on statistics page
 */
var NextChallengeComponent = (function () {
    function NextChallengeComponent(router, userService, challengeService, translate, snackBar) {
        this.router = router;
        this.userService = userService;
        this.challengeService = challengeService;
        this.translate = translate;
        this.snackBar = snackBar;
        this.inviteUserForm = new FormGroup({
            email: new FormControl('', [
                Validators.required,
                Validators.pattern(/^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/),
            ]),
        });
        // Dialog displayed when user needs to confirm that he wants to leave team
        this.displayLeaveTeamDialog = false;
        // Dialog displayed when founder needs to confirm that he wants to delete the team
        this.displayDeleteTeamDialog = false;
        // Whether team has been loaded from challenge service
        this.teamLoaded = false;
        // Reference to TeamMembershipStatus to be able to use it in template
        this.TeamMembershipStatus = TeamMembershipStatus;
        this.ngUnsubscribe = new Subject();
    }
    /**
     * Subscribe to logged in user, team of logged in user, and user object in team of logged in user
     */
    NextChallengeComponent.prototype.ngOnInit = function () {
        var _this = this;
        this.userService.currentUser.takeUntil(this.ngUnsubscribe).subscribe(function (user) {
            if (user) {
                _this.currentUser = user;
            }
        });
        this.challengeService.team.takeUntil(this.ngUnsubscribe).subscribe(function (team) {
            _this.teamLoaded = true;
            _this.team = team;
            _this.generateInvitationMailTemplate();
        });
        this.challengeService.teamUser.takeUntil(this.ngUnsubscribe).subscribe(function (teamUser) {
            _this.loggedInUser = teamUser;
        });
    };
    NextChallengeComponent.prototype.navigateSelectTeam = function (challengeID) {
        this.router.navigate(['challenge', challengeID, 'team']).then();
    };
    NextChallengeComponent.prototype.showLeaveTeamDialog = function () {
        this.displayLeaveTeamDialog = true;
        window.scrollTo(0, 0);
    };
    NextChallengeComponent.prototype.leaveTeam = function (challengeID, teamID, userID) {
        this.challengeService.removeUserFromTeam(challengeID, teamID, userID).then();
        this.displayLeaveTeamDialog = false;
    };
    NextChallengeComponent.prototype.showDeleteTeamDialog = function () {
        this.displayDeleteTeamDialog = true;
        window.scrollTo(0, 0);
    };
    NextChallengeComponent.prototype.deleteTeam = function (challengeID, teamID) {
        this.challengeService.deleteTeam(challengeID, teamID).then();
        this.displayDeleteTeamDialog = false;
    };
    /**
     * Invites a user to the team
     */
    NextChallengeComponent.prototype.inviteUserToTeam = function () {
        var _this = this;
        this.challengeService
            .inviteUsers(this.challenge._id, this.team._id, [this.inviteUserForm.value.email])
            .then(function () {
            _this.inviteUserForm.reset();
        })
            .catch(function (error) {
            var errorObject = error.body.error.error;
            if (errorObject.startsWith('invalid_domain')) {
                _this.translate.get('CHALLENGE.error.invalidInvitationDomain').subscribe(function (text) {
                    _this.snackBar.open(text, null, {
                        verticalPosition: 'top',
                        duration: 4000,
                        panelClass: ['b2a-error', 'top'],
                    });
                });
            }
            else if (errorObject.startsWith('maximum_challenge_members')) {
                _this.translate.get('CHALLENGE.error.maximumChallengeMemberReached').subscribe(function (text) {
                    _this.snackBar.open(text, null, {
                        verticalPosition: 'top',
                        duration: 4000,
                        panelClass: ['b2a-error', 'top'],
                    });
                });
            }
            else {
                _this.translate.get('CHALLENGE.error.userInviteFailed').subscribe(function (text) {
                    _this.snackBar.open(text, null, {
                        verticalPosition: 'top',
                        duration: 4000,
                        panelClass: ['b2a-error', 'top'],
                    });
                });
                _this.challengeService.reloadTeams();
            }
        });
    };
    /**
     * Accept invitation to a team
     */
    NextChallengeComponent.prototype.acceptInvitation = function (teamID, userID) {
        var _this = this;
        this.challengeService.acceptInvitation(this.challenge._id, teamID, userID).catch(function (error) {
            var errorObject = error.body.error.error;
            if (errorObject.startsWith('maximum_challenge_members')) {
                _this.translate.get('CHALLENGE.error.maximumChallengeMemberReached').subscribe(function (text) {
                    _this.snackBar.open(text, null, {
                        verticalPosition: 'top',
                        duration: 4000,
                        panelClass: ['b2a-error', 'top'],
                    });
                });
            }
            else {
                _this.translate.get('CHALLENGE.error.general').subscribe(function (text) {
                    _this.snackBar.open(text, null, {
                        verticalPosition: 'top',
                        duration: 4000,
                        panelClass: ['b2a-error', 'top'],
                    });
                    _this.challengeService.reloadTeams();
                });
            }
        });
    };
    /**
     * Cancels application of a user to the team
     */
    NextChallengeComponent.prototype.denyApplication = function (userID) {
        var _this = this;
        this.challengeService.cancelApplication(this.challenge._id, this.team._id, userID).catch(function () {
            _this.translate.get('CHALLENGE.error.general').subscribe(function (text) {
                _this.snackBar.open(text, null, {
                    verticalPosition: 'top',
                    duration: 4000,
                    panelClass: ['b2a-error', 'top'],
                });
                _this.challengeService.reloadTeams();
            });
        });
    };
    /**
     * Cancels an invitation of the user to the team
     */
    NextChallengeComponent.prototype.cancelInvitation = function (teamID, userEmail) {
        var _this = this;
        this.challengeService.declineInvitation(this.challenge._id, teamID, userEmail).catch(function () {
            _this.translate.get('CHALLENGE.error.general').subscribe(function (text) {
                _this.snackBar.open(text, null, {
                    verticalPosition: 'top',
                    duration: 4000,
                    panelClass: ['b2a-error', 'top'],
                });
                _this.challengeService.reloadTeams();
            });
        });
    };
    /**
     * On destroy cancel active subscriptions
     */
    NextChallengeComponent.prototype.ngOnDestroy = function () {
        this.ngUnsubscribe.next();
        this.ngUnsubscribe.complete();
    };
    /**
     * Team members get an option to send an email to invite company colleagues
     */
    NextChallengeComponent.prototype.generateInvitationMailTemplate = function () {
        if (!this.team) {
            return;
        }
        var mailTemplate = "mailto:?subject=Einladung%20zur%20Back2Action%20Team%20Challenge&body=Hallo%2C%0A%0AIhr%20seid%20herzlich%20eingeladen%20an%20der%20Back2Action%20Team%20Challenge%20teilzunehmen%2C%20die%20am%20%3AstartDate%20startet.%0A%0AIhr%20k%C3%B6nnt%20zwischen%20folgenden%20Optionen%20w%C3%A4hlen%3A%0A%0A-%20Anfrage%20zur%20Mitgliedschaft%20bei%20meinem%20Team%20%E2%80%9E%3AteamName%22%0A-%20Anfrage%20bei%20einem%20anderen%20Team%0A-%20oder%20ein%20eigenes%20Team%20gr%C3%BCnden%0A%0AHinweis%3A%20Die%20Teamgr%C3%B6%C3%9Fe%20ist%20beschr%C3%A4nkt%20auf%20mind.%20%3AminMembers%20und%20max.%20%3AmaxMembers%20Mitglieder.%20Wenn%20das%20Team%20voll%20ist%2C%20k%C3%B6nnen%20gerne%20weitere%20Teams%20gegr%C3%BCndet%20werden.%0A%0AFalls%20ihr%20euch%20noch%20nicht%20bei%20Back2Action%20registriert%20habt%2C%20m%C3%BCsst%20ihr%20das%20vorab%20%C3%BCber%20den%20folgenden%20Link%20tun%3A%20%3AregistrationLink%0A%0AAuf%20geht%E2%80%99s%2C%20lasst%20uns%20durchstarten!%0A%0A";
        mailTemplate = mailTemplate.replace(/%3AteamName/g, this.team.name);
        mailTemplate = mailTemplate.replace(/%3AstartDate/g, moment(this.challenge.start).format('DD.MM.YYYY'));
        mailTemplate = mailTemplate.replace(/%3AminMembers/g, this.challenge.minimalTeamMembers.toString());
        mailTemplate = mailTemplate.replace(/%3AmaxMembers/g, this.challenge.maximumTeamMembers.toString());
        // If active user belongs to a branch office, register for branch office. Else register for company.
        // Set selectTeam query param, so that user is redirected to team selection screen at first login after registration
        var registrationLink = (window.location.origin + "/signup/de/" + this.currentUser.company.registrationToken + "/")
            .concat(this.currentUser.branchoffice && this.currentUser.branchoffice.registrationToken
            ? this.currentUser.branchoffice.registrationToken
            : '')
            .concat('?selectTeam=true');
        mailTemplate = mailTemplate.replace(/%3AregistrationLink/g, registrationLink);
        this.inviteMembersTemplate = mailTemplate;
    };
    return NextChallengeComponent;
}());
export { NextChallengeComponent };



// WEBPACK FOOTER //
// /codebuild/output/src1521087412/src/client/web-client/src/app/theme/components/challenge-statistics/components/next-challenge/next-challenge.component.ts.pre-build-optimizer.js